module.exports = __webpack_public_path__ + "static/img/landing-image-2.d89f363e.jpg";